<app-dashboard>
  <div class="w-full flex flex-col gap-[30px] p-[20px]">
    <div class="w-full flex justify-end">
      <div *ngIf="canWrite" class="w-full">
        <app-button
        [label]="'New API Key'"
        (onClick)="openAddModal()"
        [className]="
          'text-[#fff] max-w-[150px] w-full h-[50px] flex items-center whitespace-nowrap justify-center rounded-[5px] bg-[#081A46] cursor-pointer'
        "
      ></app-button>
      </div>
      <div *ngIf="!canWrite" class="w-full h-[30px]"></div>
    </div>
    <div *ngIf="fetchingData" class="w-full flex flex-col gap-[10px]">
      <div class="bg-slate-100 w-full rounded-[10px] h-[70px] animate-pulse"></div>
      <div class="bg-slate-100 w-full rounded-[10px] h-[70px] animate-pulse"></div>
    </div>
    <div *ngIf="emptyState && apiKeys.length === 0" class="w-full flex justify-center items-center">
      <div class="w-fit flex flex-col gap-[5px] items-center">
        <img src="../../../assets/images/empty.svg" alt="">
        <span class="text-center text-[16px] font-[800] text-[#364152]">No Data Found</span>
        <span class="text-center text-[14px] font-[400] text-[#6B7280]">Create a new API key</span>
      </div>
    </div>
   <div *ngIf="!emptyState" class="w-full flex flex-col gap-[10px]">
    <ng-container *ngFor="let apiKey of apiKeys">
      <div  *ngIf="!fetchingData" class="webhook-card">
        <div class="name-section">
          <span class="name">{{apiKey?.name}}</span>
          <span class="type">Expires: {{formatDate(apiKey?.expiryDate)}}</span>
        </div>
        <div class="middle">
          <span class="title"
            >IP Address: <span class="data truncate">{{apiKey?.sourceIp}}</span></span
          >
        </div>
        <div class="flex gap-[5px] items-center">
          <span class="text-[12px] text-slate-800 font-[600] capitalize">{{apiKey?.status}}</span><img class="w-[16px]" src="../../../assets/icons/{{apiKey.status === 'active' ? 'check-2' : 'cancel-3'}}.svg" alt="">
        </div>
        <div class="end">
          <div *ngIf="canDelete" (click)="openDeleteModal(apiKey?._id)" class="icon-delete"></div>
        </div>
      </div>
    </ng-container>
   </div>
   <app-pagination
   *ngIf="!fetchingData && this.totalApiKeys > 0"
   [totalItems]="this.totalApiKeys"
   [(pageSize)]="this.limit"
   [(currentPage)]="this.page"
   (pageSizeChange)="this.refreshList()"
   (currentPageChange)="this.getApiKeys()"
 ></app-pagination>
  </div>
</app-dashboard>
<app-modal
  [title]="'Create New API Key'"
  [isOpen]="addModalOpen"
  (closeModalEvent)="closeAddModal()"
>
  <div *ngIf="!apiKeyCreated" class="w-full flex flex-col">
    <app-input (returnValue)="handleInput($event)" [title]="'name'" [error]="errors.name" [label]="'Name'" [placeholder]="'Enter name'" />
    <app-input [label]="'IP Address(es) (Separated by commas)'" (returnValue)="setIpAddresses($event)" [placeholder]="'eg.. 10.0.3.232'" />
    <app-dropdown [error]="errors.vault" [label]="'Vault'" (selectedValue)="handleInput($event)" [items]="vaultNames" [placeholder]="'Select vault..'" [title]="'vault'" />
    <!-- <app-dropdown [label]="'Expiry Date'" [placeholder]="'1 month'" [error]="errors.expiresIn" (selectedValue)="setApiExpiry($event)" [items]="durationOptions" /> -->
     <app-date-picker [label]="'Expiry Date'" [error]="errors.expiryDate" (returnValue)="setExpiryDate($event)" />
    <app-button
      [label]="'Create Key'"
      [loading]="loading"
      (onClick)="createApiKey()"
      [className]="
        'text-[#fff] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
      "
    ></app-button>
  </div>
  <div *ngIf="apiKeyCreated">
    <p class="form-subheading">API Key generated successfully!</p>
    <span class="extra-text">Please copy and save the generated API Key below. Once this modal is closed, It won't be displayed again.</span>
    <app-copy-text [text]="this.generatedApiKey"></app-copy-text>
</div>
</app-modal>
<app-modal
  [title]="'Create New API Key'"
  [isOpen]="deleteModalOpen"
  (closeModalEvent)="closeDeleteModal()"
>
  <div class="flex flex-col w-full gap-[30px] items-center">
    <span class="text-slate-800 text-[14px]">Delete this API Key?</span>
    <div class="w-full flex justify-end">
      <!-- <app-button
        [label]="'Close Modal'"
        (onClick)="closeDeleteModal()"
        [className]="
          'text-[#081A46] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] border border-[#081A46]'
        "
      ></app-button> -->
      <app-button
        [label]="'Delete Key'"
        (onClick)="deleteApi()"
        [loading]="loading"
        [className]="
          'text-[#fff] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
        "
      ></app-button>
    </div>
  </div>
</app-modal>
